import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { AdminFeaturesService } from '../service/admin-features.service';

@Component({
  selector: 'app-medal-tally-admin',
  templateUrl: './medal-tally-admin.component.html',
  providers: [MessageService],
})
export class MedalTallyAdminComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  events: any[] = [];
  schools: any[] = [];
  eventId: number | null = null;
  rows: any[] = [];
  loading = false;

  modalOpen = false;
  editing: any = null;
  form: any = { schoolId: null, gold: 0, silver: 0, bronze: 0 };

  constructor(private svc: AdminFeaturesService, private toast: MessageService) {}

  ngOnInit() {
    this.svc.eventList().pipe(takeUntil(this.destroy$)).subscribe((e: any[]) => {
      this.events = (e || []).map(x => ({ id: x.id, name: x.eventName || x.name || x.event_name }));
    });
    this.svc.schoolList().pipe(takeUntil(this.destroy$)).subscribe((s: any[]) => this.schools = s || []);
  }

  onEvent() { if (this.eventId) this.load(); else this.rows = []; }

  load() {
    this.loading = true;
    this.svc.resultsForEvent(this.eventId).pipe(takeUntil(this.destroy$)).subscribe((r: any[]) => {
      this.rows = r || []; this.loading = false;
    }, () => { this.loading = false; this.err('Failed to load tally'); });
  }

  total(r: any) { return (r.gold || 0) + (r.silver || 0) + (r.bronze || 0); }
  schoolName(id: number) { const s = this.schools.find(x => x.schoolId === id); return s ? s.schoolName : `School ${id}`; }

  openNew() {
    if (!this.eventId) { this.err('Pick an event first'); return; }
    this.editing = null; this.form = { schoolId: null, gold: 0, silver: 0, bronze: 0 }; this.modalOpen = true;
  }
  openEdit(r: any) {
    this.editing = r;
    this.form = { schoolId: r.schoolId, gold: r.gold, silver: r.silver, bronze: r.bronze };
    this.modalOpen = true;
  }
  close() { this.modalOpen = false; }

  save() {
    if (!this.form.schoolId) { this.err('Select a school'); return; }
    const b = {
      eventId: this.eventId, schoolId: Number(this.form.schoolId),
      gold: Number(this.form.gold) || 0, silver: Number(this.form.silver) || 0, bronze: Number(this.form.bronze) || 0,
    };
    // POST replaces the school's tally for this event (delete-then-create backend).
    this.svc.saveResult(b).pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.ok('Tally saved'); this.close(); this.load();
    }, () => this.err('Save failed'));
  }

  private ok(m: string)  { this.toast.add({ severity: 'success', summary: m }); }
  private err(m: string) { this.toast.add({ severity: 'error', summary: m }); }

  ngOnDestroy() { this.destroy$.next(); this.destroy$.complete(); }
}
